import { useSuspenseQuery } from "@tanstack/react-query";

import { ReactQueryKeysGlobal } from "services/queryKeys";

import { authService } from "./index";

export const useClaims = () => {
  const { data } = useSuspenseQuery({
    queryKey: [ReactQueryKeysGlobal.claims],
    queryFn: () => {
      return authService.getFireboltClaims();
    },
  });
  return data;
};
